module.exports = __webpack_public_path__ + "img/log2.5f9332cd.png";